import {_, React, observer, observable, computed, IDisposer, action, useEffect, classNames, useAsObservableSource, Fuse} from '@api'
import {ContentTitleBarItemField, SearchPopover, StoresInstanceContext, useVipLocalStore, VipLocalStore, ChangeLogFilterFieldConfig} from '@modules'
import {StoresInstance} from '@stores'
import {C8Hierarchy} from '@stores/c8/C8ServicesStore'
import {autorun} from 'mobx'
import * as css from './ContentTitleBarHierarchyItem.css'

/// region Store

export class ContentTitleBarHierarchyItemStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'>) {
    super(stores)
  }

  registerEffects = () => {
    const _toDispose: Array<IDisposer> = [
      autorun(async () => {
        const {getDataForC8Field} = this
        await getDataForC8Field()
      })
    ]

    return () => {
      _toDispose.forEach(d => d())
    }
  }

  @observable data: Array<any> = []

  @observable searchText: string = null

  @action onSearch = (event) => {
    this.searchText = event.target.value
  }

  @action onChange = (key, def) => {
    const {props} = this

    if (props.onChange) {
      props.onChange(key, def)
    }
  }

  @computed get results() {
    const {searchText, data, fuse} = this
    return searchText ? fuse.search(searchText).map(r => r.item) : data
  }

  @observable fuse

  getDataForC8Field = async () => {
    const {catalog: {c8: {services}}, field: {field, c8}} = this,
      {serviceName, serviceCall} = c8
    await services.getDataFromC8(field as C8Hierarchy, serviceName, serviceCall)
    this.data = _.uniqBy(services.instance[field], d => d.name)
    this.fuse = new Fuse(this.data, {keys: ['id', 'name']})
  }

  get field() {
    return this.props.field
  }

  get selected() {
    return this.props.selected
  }

  @computed get label() {
    const {field, catalog: {labelForField}} = this
    return labelForField(field) ?? field.label
  }

  @computed get text() {
    const {selected, label} = this
    return (selected?.value ?? []).length ? (selected?.value ?? []).length < 3 ? selected?.value.map(val => val.name).join(', ') : `${label}(${selected.value.length})` : `Select ${label}`
  }
}

export const ContentTitleBarHierarchyItemStoreContext = React.createContext<ContentTitleBarHierarchyItemStore>(null)
export const useContentTitleBarHierarchyItemStore = () => React.useContext(ContentTitleBarHierarchyItemStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
  field?: ChangeLogFilterFieldConfig
  stores?: StoresInstance
  selected?: any
  onChange?: Function
}

export const ContentTitleBarHierarchyItem = observer<MyProps>(function ContentTitleBarHierarchyItem({className, ...props}) {
  const obsProps = useAsObservableSource({...props}),
    store = useVipLocalStore((stores) => new ContentTitleBarHierarchyItemStore(stores, obsProps)),
    {results, field, props: {stores}, selected, onChange, onSearch, searchText, text} = store

  useEffect(() => store.registerEffects(), [])

  return (
    <StoresInstanceContext.Provider value={stores}>
      <ContentTitleBarHierarchyItemStoreContext.Provider value={store}>
        <div className={classNames(css.root, className)}>
          <SearchPopover onSearch={onSearch} searchText={searchText} text={text}>
            {results.length === 0 && <div className={css.noData}>No Search Result Found</div>}
            {results.map(value => {
              const val: any = _.isObject(value) ? value : {id: value, name: value}
              return <ContentTitleBarItemField key={val.id}
                                               field={{...field, label: val.name, value: {name: val.name, id: val.id}, workspaceLabel: ''}}
                                               isSelected={(selected?.value ?? []).some(s => s.id === val.id)}
                                               onSelectMenuItem={onChange}
                                               searchText={searchText}/>
            })}
          </SearchPopover>

        </div>
      </ContentTitleBarHierarchyItemStoreContext.Provider>
    </StoresInstanceContext.Provider>
  )

})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/titleBarItem/ContentTitleBarHierarchyItem.tsx